export default {"src":"/_next/static/media/0x31c8eacbffdd875c74b94b077895bd78cf1e64a3.242e5be8.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};